import React, { useContext, useState } from 'react';
import { Button, Modal, Toast } from '../../../../uiComponents/common';
import { useTranslation } from 'react-i18next';
import { Show } from '../../../../components';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { WelletContext } from '../../../../context/wellet/welletContext';
import { useMutation } from 'react-query';
import { resetEmail } from '../../../../services';
import InputEmail from '@/uiComponents/common/inputs/shadcn/inputEmailForm';
import { Pencil } from 'lucide-react';
import { Button as ButtonShad } from '@/components/ui/button';

const ChangeMailModal = ({ setValue, email = null, canEditEmail }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'screens.profile',
  });

  const { id } = useParams();

  const methods = useForm({
    defaultValues: {
      email: email,
    },
  });

  // const { id } = useParams();
  const welletContext = useContext(WelletContext);
  const [open, setOpen] = useState(false);

  const handleSetNewEmail = (email) => {
    setValue('email', email);
  };
  // Mutation
  const handleEmailMutation = useMutation({
    mutationFn: (body) => {
      const response = resetEmail(welletContext, id, body.email);
      return response;
    },
    onSuccess: (data, variables) => {
      handleSetNewEmail(variables?.email);
    },
  });

  const handleCancel = () => {
    setOpen(false);
    methods.reset({
      email: email,
    });
  };
  const closeModal = () => {
    setOpen(false);
  };
  const openModal = () => {
    setOpen(true);
  };
  const onSubmit = (data) => {
    const body = {
      email: data?.email,
    };
    handleEmailMutation.mutate(body);
  };
  return (
    <>
      {canEditEmail ? (
        <ButtonShad
          size='icon'
          variant='ghost'
          type='button'
          className='tw-absolute tw-right-1 tw-top-1 tw-h-8 tw-w-8'
          onClick={openModal}
        >
          <Pencil className='tw-h-4 tw-w-4' />
        </ButtonShad>
      ) : null}
      <Modal
        title={t('changeMailModal.title')}
        open={open}
        onClose={closeModal}
        closeIcon={false}
        maxWidth='550px'
        closeOnDocumentClick={false}
        customButtons={
          <>
            <div className='d-flex justify-content-end'>
              <Button
                text={t('changeMailModal.cancel')}
                disabled={!handleEmailMutation.isIdle}
                className={'btn-general btn-wellet-secondary white'}
                size={'medium'}
                onClick={handleCancel}
                type='button'
              />
              <Button
                text={t('changeMailModal.submit')}
                disabled={!handleEmailMutation.isIdle}
                className={'ml-2 btn-general btn-wellet-primary'}
                size={'medium'}
                onClick={methods.handleSubmit(onSubmit)}
                type='submit'
              />
            </div>
          </>
        }
      >
        <FormProvider {...methods}>
          <div className='tw-text-muted-foreground'>{t('changeMailModal.subtitle')}</div>
          <form key={'mailChange'} className='tw-my-3'>
            <InputEmail
              name={'email'}
              label={t('rowPersonalInfo.inputEmail.label')}
              placeholder={t('rowPersonalInfo.inputEmail.placeholder')}
              isRequired={true}
            />
          </form>
        </FormProvider>
      </Modal>
      <Show.When isTrue={handleEmailMutation.isError}>
        <Toast
          message={
            handleEmailMutation?.error?.response?.data?.errorCode === 'EMAIL_ALREADY_EXISTS'
              ? t('changeMailModal.toast.errorEmailAlready')
              : handleEmailMutation?.error?.response?.data?.errorCode === 'ERROR_MODIFY_EMAIL'
              ? t('changeMailModal.toast.invalid')
              : t('changeMailModal.toast.error')
          }
          type={`ERROR`}
          onCallback={() => {
            // handleCloseError();
            handleEmailMutation.reset();
          }}
        />
      </Show.When>
      <Show.When isTrue={handleEmailMutation.isSuccess}>
        <Toast
          message={t('changeMailModal.toast.success')}
          type={`SUCCESS`}
          onCallback={() => {
            closeModal();
            handleEmailMutation.reset();
          }}
        />
      </Show.When>
    </>
  );
};

export default ChangeMailModal;
